import "@hotwired/turbo-rails"
import Chartkick from "chartkick"
import Chart from "chart.js/auto"
import "chartjs-adapter-date-fns"

Chartkick.use(Chart)
import { StreamActions } from "@hotwired/turbo"
import "@37signals/lexxy"
// Import Lexxy CSS via relative paths (package exports only expose the JS entry).
// Keep these out of application.css so nested @import url("lexxy-variables.css")
// is resolved per-file by Vite instead of landing mid-stylesheet after Tailwind.
import "../../../node_modules/@37signals/lexxy/dist/stylesheets/lexxy-variables.css"
import "../../../node_modules/@37signals/lexxy/dist/stylesheets/lexxy-content.css"
import "../../../node_modules/@37signals/lexxy/dist/stylesheets/lexxy-editor.css"
import "@rails/actiontext"
import "@rails/activestorage"

import { Application } from "@hotwired/stimulus"
import { registerControllers } from 'stimulus-vite-helpers'

const application = Application.start()

const controllers = import.meta.glob('../controllers/**/*_controller.js', { eager: true })

registerControllers(application, controllers)

window.Stimulus = application

// Custom Turbo Stream action for redirects
StreamActions.redirect = function () {
  const url = this.getAttribute("url")
  if (!url) return

  // Navigate via a same-window link click so Hotwire Native RouteDecisionHandlers
  // can open external payment URLs in-app and return to the app host.
  const link = document.createElement("a")
  link.href = url
  link.click()
}

// Custom Turbo Stream action to dispatch custom events
// Usage: <turbo-stream action="dispatch_event" event_name="side-menu:open"></turbo-stream>
StreamActions.dispatch_event = function () {
  const eventName = this.getAttribute("lesson_name")
  if (eventName) {
    window.dispatchEvent(new CustomEvent(eventName))
  }
}

// Do not cache flash toasts — otherwise browser/native back re-shows them.
document.addEventListener("turbo:before-cache", () => {
  const flash = document.getElementById("flash")
  if (flash) flash.replaceChildren()
})

console.log('Vite ⚡️ Rails ⚡️ Stimulus')